import PropTypes from "prop-types";

/**
 * PropTypes for Dropdown title/trigger component.
 *
 * @property {string} [className] - Optional className for the trigger button
 * @property {boolean} [hideIcon] - When true, hides the chevron icon
 */
export const dropdownTitlePropTypes = {
  className: PropTypes.string,
  hideIcon: PropTypes.bool,
};

/**
 * PropTypes for Dropdown content wrapper component.
 *
 * @property {string} [className] - Optional className for the content wrapper
 * @property {React.ReactNode} [children] - Menu items to render
 */
export const dropdownContentPropTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

/**
 * PropTypes for Dropdown menu item component.
 *
 * @property {React.ReactNode} [children] - Item label/content
 * @property {Function} [onClick] - Click handler for the item
 * @property {string} [className] - Optional className for the item
 */
export const dropdownItemPropTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

/**
 * PropTypes for nested dropdown item (submenu) component.
 *
 * @property {{name: string, value?: string|number, children?: Array<{name: string, value?: string|number}>}} item - Item data with optional children
 * @property {Function} [onClick] - Handler invoked when an item (parent or child) is selected
 */
export const dropdownNestedItemPropTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    children: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      })
    ),
  }).isRequired,
  onClick: PropTypes.func,
};
